export const sharpelyBaseImg = "https://d3etfstcuyoos5.cloudfront.net/app-images/imgs/sharpely-asset/"
const sharpelyLoginImg = "https://d3etfstcuyoos5.cloudfront.net/app-images/login_page_imgs/";
const sharpelyBaseImg2 = "https://d3etfstcuyoos5.cloudfront.net/app-images/"

// sharpely logos
export const sharpelyLogoLight = sharpelyBaseImg + 'sharpely_logos/light_name_logo.webp'
export const sharpelyLogoDark = sharpelyBaseImg + 'sharpely_logos/dark_name_logo.webp'
export const sharpelyOnlyLogo = sharpelyBaseImg + 'sharpely_logos/logo.webp'